import { useEffect, useMemo, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { DashboardLayout } from "./widgets/DashboardLayout";
import { LoginPage } from "./layouts/login/LoginPage";
import { HomePage } from "./layouts/home/HomePage";
import { TicketsListPage } from "./layouts/tickets/TicketsListPage";
import { NewTicketPage } from "./layouts/tickets/NewTicketPage";
import { TicketDetailPage } from "./layouts/tickets/TicketDetailPage";
import { AdminDashboardPage } from "./layouts/admin/AdminDashboardPage";
import { DeploymentPage } from "./layouts/admin/DeploymentPage";
import { ReleaseNotesPage } from "./layouts/release-notes/ReleaseNotesPage";
import { loadSession, SESSION_CHANGED_EVENT } from "./services/sessionAuth";
import { isSuperAdmin, rolesOf } from "./utils/authorization";

export default function App() {
  const [session, setSession] = useState(() => loadSession());

  useEffect(() => {
    const onChange = () => setSession(loadSession());
    window.addEventListener(SESSION_CHANGED_EVENT, onChange);
    return () => window.removeEventListener(SESSION_CHANGED_EVENT, onChange);
  }, []);

  const roles = useMemo(() => rolesOf(session?.profile), [session]);
  const authed = Boolean(session?.access_token);
  const admin = isSuperAdmin(roles);

  if (!authed) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <DashboardLayout superAdmin={admin}>
      <Routes>
        {admin ? (
          <>
            <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
            <Route path="/admin/deployment" element={<DeploymentPage />} />
            <Route path="/admin/tickets" element={<TicketsListPage roles={roles} admin />} />
            <Route path="/admin/tickets/:id" element={<TicketDetailPage roles={roles} />} />
            <Route path="/release-notes" element={<ReleaseNotesPage />} />
            <Route path="/home" element={<HomePage />} />
            <Route path="/tickets/new" element={<NewTicketPage />} />
            <Route path="/tickets/:id" element={<TicketDetailPage roles={roles} />} />
            <Route path="/tickets" element={<TicketsListPage roles={roles} />} />
            <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
          </>
        ) : (
          <>
            <Route path="/home" element={<HomePage />} />
            <Route path="/tickets" element={<TicketsListPage roles={roles} />} />
            <Route path="/tickets/new" element={<NewTicketPage />} />
            <Route path="/tickets/:id" element={<TicketDetailPage roles={roles} />} />
            <Route path="/release-notes" element={<ReleaseNotesPage />} />
            <Route path="*" element={<Navigate to="/home" replace />} />
          </>
        )}
      </Routes>
    </DashboardLayout>
  );
}
